import { showSuccess, showResponseError } from 'utils/messages';

import DropdownSelections from 'app/collections/dropdown_selections';
import PopupBaseView from 'app/components/popup_base';
import SelectorView from 'app/views/selector_view';

import tmpl from './template';

export class FormField {
  constructor({
    type = 'text', label, paramKey, defaultValue = '', placeholder = '',
  }) {
    this.type = type;
    this.label = label;
    this.paramKey = paramKey;
    this.defaultValue = defaultValue;
    this.placeholder = placeholder;
  }
}

export default PopupBaseView.extend({
  compiledTemplate: tmpl,

  events: {
    ...PopupBaseView.prototype.events,
    'submit form': 'create',
  },

  initialize({
    title,
    objectName,
    ModelClass,
    dropdownSelections = new DropdownSelections([]),
    formFields = [],
    onCreate = () => {},
  }) {
    this.title = title;
    this.objectName = objectName;
    this.ModelClass = ModelClass;
    this.dropdownSelections = dropdownSelections;
    this.formFields = formFields;
    this.onCreate = onCreate;

    this.dropdownSelections.forEach((dropdownSelection, idx) => {
      this.addSubview(
        this.computeSelectionViewId(idx),
        `#${this.computeSelectionViewId(idx)}`,
        new SelectorView({ model: dropdownSelection }),
      );
    });
  },

  context() {
    return {
      title: this.title,
      objectName: this.objectName,
      dropdownSelections: this.dropdownSelections,
      formFields: this.formFields,
      computeSelectionViewId: this.computeSelectionViewId.bind(this),
    };
  },

  create(event) {
    event.preventDefault();

    let params = this.dropdownSelections.getParams();
    params = this.formFields.reduce((obj, formField) => {
      const key = formField.paramKey;
      return { ...obj, [key]: this.$(`input[name="${key}"]`).val() };
    }, params);

    const self = this;
    new this.ModelClass().save({ ...params }, {
      wait: true,
      success() {
        self.trigger('create'); // FIXME: this can go away once api keys page follows the pattern that webhooks does
        self.onCreate();
        showSuccess(`${self.objectName} Successfully Created.`);
        self.hidePopup();
      },
      error(model, response) {
        showResponseError(response);
        self.hidePopup();
      },
    });
  },
});



// WEBPACK FOOTER //
// ./app/components/popup_create_form/index.js